import { useState } from 'react'
import Button from '../../../components/common/Button'
import Input from '../../../components/common/Input'
import api from '../../../utils/api'
import { toast } from '../../../components/toast/CustomToast'

const CredentialsStep = ({ formData, setFormData, setCredentialsValidated, onNext, onBack, loading, error }) => {
  const [validationError, setValidationError] = useState('')
  const [validating, setValidating] = useState(false)
  const [isCompanyActive, setIsCompanyActive] = useState(false)

  const handleValidate = async () => {
    setValidationError('')

    if (!formData.companyId.trim()) {
      setValidationError('Por favor, informe o ID da empresa')
      return
    }

    if (!formData.token.trim()) {
      setValidationError('Por favor, informe o token de API')
      return
    }

    setValidating(true)
    try {
      // Validate company exists
      const companyValidation = await api.get(`/company-activation/validate/${formData.companyId}`)

      if (!companyValidation.data) {
        setValidationError('Empresa não encontrada')
        setValidating(false)
        return
      }

      // Check if company is already activated
      if (companyValidation.data.is_activated) {
        setValidationError('Esta empresa já foi ativada! Entre em contato com o suporte se precisar reativar.')
        setIsCompanyActive(true)
        setCredentialsValidated(false)
        setValidating(false)
        return
      }

      setIsCompanyActive(false)

      // Validate token
      const tokenValidation = await api.post('/api-tokens/validate', {
        token: formData.token
      })

      const data = tokenValidation.data

      if (!data.valid) {
        setValidationError(data.message || 'Token inválido')
        setValidating(false)
        return
      }

      if (data.company_id !== formData.companyId) {
        setValidationError('O ID da empresa não corresponde ao token fornecido')
        setValidating(false)
        return
      }

      setFormData({
        ...formData,
        validatedCompany: {
          company_id: data.company_id,
          company_name: data.company_name,
          integration_ids: data.integration_ids,
          integration_names: data.integration_names
        }
      })

      setCredentialsValidated(true)
      toast.success('Token validado com sucesso!')
      setValidating(false)
      onNext()
    } catch (err) {
      const errorMsg = err.response?.data?.detail || 'Erro ao validar token. Tente novamente.'
      setValidationError(errorMsg)
      setCredentialsValidated(false)
      setValidating(false)
    }
  }

  return (
    <div className="animate-fade-in">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
        Credenciais de Ativação
      </h2>

      <div className="space-y-4 mb-6">
        <Input
          label="ID da Empresa"
          placeholder="ex: 550e8400-e29b-41d4-a716-446655440000"
          value={formData.companyId}
          onChange={(e) => setFormData({ ...formData, companyId: e.target.value })}
          disabled={validating}
          icon={<span className="material-icons text-sm">business</span>}
        />

        <div>
          <label className="block text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">
            Token de API
          </label>
          <textarea
            value={formData.token}
            onChange={(e) => setFormData({ ...formData, token: e.target.value })}
            placeholder="Cole seu token de API aqui"
            disabled={validating}
            className="
              w-full px-4 py-3 rounded-lg
              border border-gray-300 dark:border-gray-600
              bg-white dark:bg-gray-800
              text-gray-900 dark:text-gray-100
              placeholder-gray-500 dark:placeholder-gray-400
              focus:outline-none focus:ring-2 focus:ring-blue-500
              disabled:bg-gray-100 dark:disabled:bg-gray-700
              font-mono text-xs
              resize-none
              h-24
            "
          />
        </div>
      </div>

      {(validationError || error) && (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6">
          <p className="text-red-800 dark:text-red-200 text-sm">{validationError || error}</p>
        </div>
      )}

      <div className="flex gap-3">
        <Button variant="secondary" onClick={onBack} disabled={validating || isCompanyActive} className="flex-1">
          Voltar
        </Button>
        <Button
          variant="primary"
          onClick={handleValidate}
          loading={validating}
          disabled={validating || isCompanyActive || !formData.companyId.trim() || !formData.token.trim()}
          className="flex-1"
        >
          Validar e Continuar
        </Button>
      </div>
    </div>
  )
}

export default CredentialsStep
